export default __webpack_public_path__ + "static/media/7.04352778.jpg";